export enum CybermetrieEnum {
  CATEGORIE_TRANSACTION = 'Transaction',
  CATEGORY_INTERACTIONS_FORMES = 'Interractions Forms',
  ACTION_CLIC = 'Clic',
  ACTION_DEBUTE = 'debute',
  ACTION_ETAPE = 'etape-2',
  ACTION_COMPLETE = 'complete',
  ACTION_ERREUR_UTILISATEUR = 'erreur utilisateur',
  ACTION_EOF = 'eof',
  // Credit
  CATEGORIE_GESTION_CARTE = 'Gestion carte de credit',
  ACTION_AJOUTER = 'ajouter',
  ACTION_AFFICHAGE = 'Affichage',
  ACTION_ERREUR_TECHNIQUE = 'erreur technique',
  LABEL_MODIFIER_COORDONNEES = 'modifier coordonnees - carte de credit',
  LABEL_PLUSIEURS_COURRIELS = 'modifier coordonnees - carte de credit - plusieurs courriels',
  LABEL_BOUTON_MODIFIER_ADRESSE = 'modifier coordonnees - carte de credit - modifier - adresse principale',
  LABEL_BOUTON_MODIFIER_TELEPHONE = 'modifier coordonnees - carte de credit - modifier - telephone',
  LABEL_BOUTON_MODIFIER_COURRIEL = 'modifier coordonnees - carte de credit - modifier - courriel',
  LABEL_MODIFIER_ADRESSE = 'trx - modifier coordonnees - carte de credit|adresse principale',
  LABEL_MODIFIER_TELEPHONE = 'trx - modifier coordonnees - carte de credit|telephone',
  LABEL_MODIFIER_COURRIEL = 'trx - modifier coordonnees - carte de credit|courriel',
  LABEL_MODIFIER_INFOS = 'trx - modifier coordonnees - carte de credit|',
  LABEL_MODIFIER_VALIDATION = 'modifier coordonnees - carte de credit - modifier validation ',
  LABEL_INFOS_TOTAL = 'trx - modifier coordonnees - carte de credit',
  EMPLOYEUR = 'employeur',
  SECONDAIRE = 'secondaire',
  UNE_CARTE_CREDIT = '1 carte',
  PLUSIEURS_CARTES_CREDIT = 'plusieurs cartes',
  AUCUNE_CARTE_CREDIT = 'aucune carte de crédit',
  MESSAGE_ERREUR = 'messageErreur',
  EXTRA_ATTRIBUT = 'extraAttribut',
  OUI = 'oui',
  NON = 'non',
  // Bancaire
  CATEGORIE_GESTION_BANCAIRE = 'Gestion bancaire',
  ACTION_ENTREE = 'entree',
  ACTION_ANNULER = 'annuler',
  ACTION_RADIO_BOUTON = 'debute | conserver la meme adresse | saisis',
  LABEL_BANCAIRE_TRX = 'trx - modifier coordonnees - bancaire',
  LABEL_BANCAIRE_MODIFIER = 'modifier coordonnees - bancaire - modifier',
  LABEL_BANCAIRE_COORDONNEES_CREDIT = 'modifier coordonnees - bancaire - coordonnees cc',
  LABEL_BANCAIRE_AUTRES_PRODUITS = 'modifier coordonnees - bancaire - autres produits',
  LABEL_BANCAIRE_PLANIFIER_APPEL = 'modifier coordonnees - bancaire - planifier un appel',
  LABEL_BANCAIRE = 'modifier coordonnees - bancaire',
  LABEL_BANCAIRE_AJOUTER_TELEPHONE_SECONDIRE = 'modifier coordonnees - bancaire - ajouter un telephone secondaire',
  LABEL_BANCAIRE_AJOUTER_TELEPHONE_TRAVAIL = 'modifier coordonnees - bancaire - ajouter un telephone au travail',
  LABEL_BANCAIRE_VALIDER = 'modifier coordonnees - bancaire - valider',
  LABEL_BANCAIRE_CONFIRMER = 'modifier coordonnees - bancaire - confirmer',
  LABEL_BANCAIRE_SECURITE = 'modifier coordonnees - bancaire - mettre a jour securite',
  LABEL_BANCAIRE_SUPPRIMER_TELEPHONE = 'modale - supprimer le telephone',
  LABEL_BANCAIRE_SUPPRIMER_ADRESSE = 'modale - supprimer adresse',
  MESSAGE_ERREUR_BANCAIRE = 'ne peut pas consulter les coordonnees de ses comptes',

  UN_COMPTE = '1 compte',
  PLUSIEURS_COMPTE = 'plusieurs comptes',
}
